/* Age gate for the Worth The Wait landing page only.
   Reads the same storage keys the storefront gate writes, so a visitor who has
   already passed the site gate is never asked twice. Writes both keys back for
   the same reason. Deliberately does NOT call redirectChecker(): that function
   is referenced by the storefront gate but is not defined anywhere, so calling
   it throws and aborts the handler. */
(function () {
  var COOKIE = 'user_selected_state';
  var LS_KEY = 'mt_user_selected_state';
  var DAYS = 30;

  function getCookie(name) {
    var parts = ('; ' + document.cookie).split('; ' + name + '=');
    if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
    return null;
  }
  function setCookie(name, value, days) {
    document.cookie = name + '=' + encodeURIComponent(value) +
      '; path=/; max-age=' + (days * 86400) + '; SameSite=Lax; Secure';
  }
  function readLocal(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }
  function writeLocal(key, value) {
    try { localStorage.setItem(key, value); } catch (e) { /* private mode */ }
  }

  function start() {
    var gate = document.querySelector('.senAge');
    if (!gate) return;

    var select = gate.querySelector('.senAgeState');
    var proceed = gate.querySelector('.senAgeProceed');
    var exit = gate.querySelector('.senAgeExit');
    var error = gate.querySelector('.senAgeError');

    var allowed = {};
    Array.prototype.forEach.call(select.options, function (o) {
      if (o.value) allowed[o.value] = true;
    });

    var passed = getCookie(COOKIE) || readLocal(LS_KEY);
    if (passed && allowed[passed]) {
      gate.remove();
      return;
    }

    var cleared = false;
    function unlock(state) {
      cleared = true;
      setCookie(COOKIE, state, DAYS);
      writeLocal(LS_KEY, state);
      gate.close();
      document.body.classList.remove('senAgeLock');
    }

    if (typeof gate.showModal === 'function') {
      gate.showModal();
    } else {
      gate.setAttribute('open', '');   /* <dialog>-less browsers still see the gate */
    }
    document.body.classList.add('senAgeLock');
    /* Safari has been inconsistent about autofocus inside <dialog>, and the
       fallback path below never runs it at all, so set it explicitly. */
    try { proceed.focus({ preventScroll: true }); } catch (e) { proceed.focus(); }

    proceed.addEventListener('click', function () {
      select.classList.add('is-open');
      error.classList.remove('is-open');
      select.focus();
    });

    exit.addEventListener('click', function () {
      error.classList.add('is-open');
      select.classList.remove('is-open');
      proceed.disabled = true;
    });

    select.addEventListener('change', function (event) {
      var state = event.target.value;
      if (!state || !allowed[state]) return;
      unlock(state);
    });

    /* Escape, the backdrop and the close event must not let anyone past. */
    gate.addEventListener('cancel', function (event) { event.preventDefault(); });
    gate.addEventListener('close', function () {
      if (cleared) return;
      setTimeout(function () { if (!gate.open) gate.showModal(); }, 0);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && gate.open && !cleared) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}());
